import { buildClassesHook } from '../../helpers/styles';

export const useClasses = buildClassesHook({
    workQueueTableContainer: {
        whiteSpace: 'nowrap',
        height: '100%'
    }
});
